import React from 'react'
import PropTypes from 'prop-types'
import Summernote from 'components/summernote/SummerNote'
import withFormLanguages from 'hocs/bases/withFormLanguages'
import { updateObject } from 'helpers/objectHelpers'

const EnhancedSummernote = withFormLanguages()(Summernote.StoreEditor)

const FormRichTextLanguage = ({
  elementId,
  value,
  onChange,
}) => {
  // console.log('id', id)
  return (
    <EnhancedSummernote
      value={value.html}
      onChange={(val) => onChange(updateObject(value, { html: val }))}
      createPropsByLang={(lang) => ({
        editorId: `${elementId}-${lang}`,
      })}
    />
  )
}

FormRichTextLanguage.propTypes = {
  elementId: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default FormRichTextLanguage



// WEBPACK FOOTER //
// ./src/components/forms/FormRichTextLanguage.js